import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedPhotoReference } from '../../models/serializable/localized-photo-reference.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { MapUtils } from '../../utility/map-utils.js';
import { RenderableComponent } from '../core/component.js';

export class BookNowComponent extends RenderableComponent {
  static readonly TYPE_ID: string = 'cdc7908f88fa4f64aacc5940f852ee29';
  static readonly DEFAULT_RENDER_ORDER: number = 0;

  constructor(
    public readonly titles: LocalizedString,
    public readonly descriptions: LocalizedString,
    public readonly photos: LocalizedPhotoReference,
    public readonly businessId: string | null = null,
    public readonly dynamicLink: string | null = null,
    public renderOrder: number,
    public isRenderingEnabled: boolean,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return BookNowComponent.TYPE_ID;
  }

  static empty(renderOrder: number = this.DEFAULT_RENDER_ORDER): BookNowComponent {
    return new BookNowComponent(
        LocalizedString.empty(),
        LocalizedString.empty(),
        LocalizedPhotoReference.empty(),
        null,
        null,
        renderOrder,
        true,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): BookNowComponent {
    return new BookNowComponent(
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'titles')),
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'descriptions')),
        context.fromData<LocalizedPhotoReference>(MapUtils.get<SerializedData>(map, 'photos')),
        MapUtils.getOrNull<string>(map, 'businessId'),
        MapUtils.getOrNull<string>(map, 'dynamicLink'),
        MapUtils.get<number>(map, 'renderOrder'),
        MapUtils.get<boolean>(map, 'isRenderingEnabled'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'titles': context.toData(this.titles),
      'descriptions': context.toData(this.descriptions),
      'photos': context.toData(this.photos),
      'businessId': this.businessId,
      'dynamicLink': this.dynamicLink,
      'renderOrder': this.renderOrder,
      'isRenderingEnabled': this.isRenderingEnabled,
    };
  }

  clone(): this {
    return new BookNowComponent(
        this.titles.clone(),
        this.descriptions.clone(),
        this.photos.clone(),
        this.businessId,
        this.dynamicLink,
        this.renderOrder,
        this.isRenderingEnabled,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.titles, this.titles) &&
      isSameData(other.descriptions, this.descriptions) &&
      isSameData(other.photos, this.photos) &&
      other.businessId === this.businessId &&
      other.dynamicLink === this.dynamicLink &&
      other.renderOrder === this.renderOrder &&
      other.isRenderingEnabled === this.isRenderingEnabled;
  }
}

export class BookNowComponentBuilder extends DataModelBuilder<BookNowComponent> {
  build(context: SerializationContext, map: SerializedData): BookNowComponent {
    return BookNowComponent.fromMap(context, map);
  }
}
